<div class="cart-header">
  <button class="change-project-button" mat-button
          (click)="changeProject()" [tabindex]="-1">{{cart.project ? cart.project.name : 'Choose Project'}}</button>
</div>

<div class="cart-sections">
  <div class="cart-num-mask">
    <div class="cart-num">{{cart.number}}</div>
  </div>

  <div class="cart-section" *ngFor="let section of visualCart.sections" [ngClass]="section.classes">
    <div class="item-section {{itemSection.classes.join(' ')}}" *ngFor="let itemSection of section.traySections"
         [ngClass]="{'full-section':
         traysMap.get(itemSection.trayNumber)?.tray.filledQty > 0 &&
         traysMap.get(itemSection.trayNumber)?.tray.filledQty >= traysMap.get(itemSection.trayNumber)?.tray.totalQty}"
         (click)="changeCab(itemSection.trayNumber)">
      <div class="section-num-mask">
        <div class="section-num">
          {{itemSection.trayNumber}}
        </div>
        <div class="space-block cab-string">
          <span
            *ngIf="traysMap.get(itemSection.trayNumber)?.cabinetsString">{{traysMap.get(itemSection.trayNumber)?.cabinetsString}}</span>
        </div>
        <div class="section-counter">
          {{traysMap.get(itemSection.trayNumber)?.tray.filledQty}}/{{traysMap.get(itemSection.trayNumber)?.tray.totalQty}}
        </div>
      </div>
    </div>
  </div>
</div>

<div class="cart-footer">
<!--  <ng-container *ngIf="lastScannedString"><span class="scan-label">Last Scan -</span>{{lastScannedString}}</ng-container>-->
  <ng-container *ngIf="lastScannedString">{{lastScannedString}}</ng-container>
</div>
